import { render, staticRenderFns } from "./pysznyDetails.vue?vue&type=template&id=05cc3388"
import script from "./pysznyDetails.vue?vue&type=script&lang=js"
export * from "./pysznyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports